import '../css/rolex-v7.less';

import { initRoutes } from '@eidellev/adonis-stardust/client';
initRoutes();

// import smoothScroll from './modules/smooth-scrolling';
import Flickity from 'flickity';

import './rolex/contact-form';
// import './rolex/map';
import './rolex/watch-grid';
import './rolex/watch-grid-filter';
import './rolex/watch-grid-feature';
import './rolex/analytics';

import { initSimpleMap, initComplexMap } from './rolex/map';

import './rolex/subnav';

document.addEventListener('DOMContentLoaded', () => {
  initSimpleMap();
  initComplexMap();
});

// // some of the sliders position the buttons centered to the image, not the entire slide

const positionSliderBtns = () => {
  let sliders = document.querySelectorAll('.js-rlx-ke-slider');

  sliders.forEach((elem) => {
    let btns = elem.querySelectorAll<HTMLInputElement>('.js-prev, .js-next');

    let sliderImage = elem.querySelector('.js-slide img') as HTMLElement;

    btns.forEach((btn) => {
      btn.style.top = `${sliderImage?.offsetHeight / 2}px`;
    });
  });
};

// Hero slider

function toggleButtonClass(element: HTMLInputElement, mode: 'light' | 'dark'): void {
  if (mode === 'light') {
    element.classList.add('rlx-slider-btn--light');
    element.classList.remove('rlx-slider-btn--dark');
  } else {
    element.classList.add('rlx-slider-btn--dark');
    element.classList.remove('rlx-slider-btn--light');
  }
}

const heroSliders = document.querySelectorAll('.js-rlx-hero-slider');

heroSliders.forEach((elem) => {
  let slider = new Flickity(elem, {
    cellSelector: '.js-slide',
    wrapAround: false,
    cellAlign: 'left',
    prevNextButtons: false,
    selectedAttraction: 0.012,
  });

  let prev = elem.querySelector('.js-prev') as HTMLInputElement;
  let next = elem.querySelector('.js-next') as HTMLInputElement;

  prev?.addEventListener('click', () => {
    slider.previous();
  });

  next?.addEventListener('click', () => {
    slider.next();
  });

  let slides = slider.getCellElements();

  slider.on('change', (index) => {
    let numSlides = slider.slides.length;
    const style = slides[index].dataset.style ?? 'light';

    toggleButtonClass(prev, style);
    toggleButtonClass(next, style);

    if (style === 'light') {
      elem.classList.add('rlx-slider--light');
      elem.classList.remove('rlx-slider--dark');
    } else {
      elem.classList.add('rlx-slider--dark');
      elem.classList.remove('rlx-slider--light');
    }

    if (index === 0) {
      prev?.setAttribute('disabled', 'true');
      next?.removeAttribute('disabled');
    } else if (index === numSlides - 1) {
      prev?.removeAttribute('disabled');
      next?.setAttribute('disabled', 'true');
    } else {
      prev?.removeAttribute('disabled');
      next?.removeAttribute('disabled');
    }
  });
});

let hoursToggle = document.querySelector('.js-rlx-hours-toggle');

hoursToggle?.addEventListener('click', (e) => {
  e.preventDefault();

  let rolexHours = document.querySelector('.js-rlx-hours') as HTMLElement;

  if (rolexHours && rolexHours.classList.contains('open')) {
    hoursToggle?.classList.remove('open');
    rolexHours.style.maxHeight = '';
    rolexHours.classList.remove('open');
    rolexHours.setAttribute('aria-hidden', 'true');
  } else {
    hoursToggle?.classList.add('open');
    rolexHours.style.maxHeight = `${rolexHours.scrollHeight}px`;
    rolexHours.classList.add('open');
    rolexHours.removeAttribute('aria-hidden');
  }
});

const keSliders = document.querySelectorAll('.js-rlx-ke-slider');

keSliders.forEach((elem) => {
  let slider = new Flickity(elem, {
    cellSelector: '.js-slide',
    wrapAround: false,
    cellAlign: 'left',
    prevNextButtons: false,
    groupCells: true,
    selectedAttraction: 0.012,
    contain: true,
  });

  // remove Flickity's tabindex to avoid invisible focus, these sliders have links so its fine
  elem.removeAttribute('tabindex');

  let prev = elem.querySelector('.js-prev');
  let next = elem.querySelector('.js-next');

  prev?.addEventListener('click', () => {
    slider.previous();
  });

  next?.addEventListener('click', () => {
    slider.next();
  });

  slider.on('change', () => {
    let numSlides = slider.slides.length;
    let index = slider.selectedIndex;

    if (index === 0) {
      prev?.setAttribute('disabled', 'true');
      next?.removeAttribute('disabled');
    } else if (index === numSlides - 1) {
      prev?.removeAttribute('disabled');
      next?.setAttribute('disabled', 'true');
    } else {
      prev?.removeAttribute('disabled');
      next?.removeAttribute('disabled');
    }
  });

  positionSliderBtns();
});

// when slider images load we need to fire a resize to adjust slider
let sliderImages = document.querySelectorAll('.js-slide img');

Array.from(sliderImages).forEach((img) => {
  img.addEventListener('load', () => {
    window.dispatchEvent(new Event('resize'));
    positionSliderBtns();
  });
});

window.onresize = positionSliderBtns;

// // Tooltip
const mouse = new Event('mouseclick');
const touch = new Event('touch');

document.addEventListener('pointerdown', ({ pointerType, target }) => {
  if (pointerType === 'mouse') {
    (target as HTMLElement)?.dispatchEvent(mouse);
  }
  if (pointerType === 'touch') {
    (target as HTMLElement)?.dispatchEvent(touch);
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const tooltips = document.querySelectorAll<HTMLElement>('.js-tooltip-trigger');

  tooltips.forEach((tooltip) => {
    const content = tooltip.nextElementSibling as HTMLElement | null;

    if (content) {
      const showTooltip = () => content.removeAttribute('aria-hidden');
      const hideTooltip = (event: MouseEvent) => {
        if (!tooltip.contains(event.relatedTarget as Node) && !content.contains(event.relatedTarget as Node)) {
          content.setAttribute('aria-hidden', 'true');
        }
      };

      tooltip.addEventListener('mouseover', showTooltip);
      tooltip.addEventListener('mouseleave', hideTooltip);
      tooltip.addEventListener('focusin', showTooltip);
      tooltip.addEventListener('blur', hideTooltip);
    }
  });

  // Model page gallery

  const modelSliders = document.querySelectorAll('.js-rlx-model-slider');

  modelSliders.forEach((elem) => {
    let slider = new Flickity(elem, {
      cellSelector: '.js-slide',
      wrapAround: true,
      cellAlign: 'left',
      prevNextButtons: false,
      groupCells: true,
      selectedAttraction: 0.012,
      contain: true,
      watchCSS: true,
    });

    // Prevent opening on drag
    slider.on('dragStart', () => slider.slider.childNodes.forEach((slide) => slide.style.pointerEvents = 'none'));
    slider.on('dragEnd', () => slider.slider.childNodes.forEach((slide) => slide.style.pointerEvents = 'all'));
  });

  const modelModalSliders = document.querySelectorAll('.js-rlx-model-modal-slider');
  const modelModalBtns = document.querySelectorAll<HTMLButtonElement>('.js-rlx-gallery-btn');

  modelModalSliders.forEach((elem) => {
    let slider = new Flickity(elem, {
      cellSelector: '.js-slide',
      wrapAround: true,
      cellAlign: 'left',
      prevNextButtons: false,
      groupCells: true,
      selectedAttraction: 0.012,
      contain: true,
      pageDots: false,
    });

    // remove Flickity's tabindex to avoid invisible focus, these sliders have links so its fine
    elem.removeAttribute('tabindex');

    let prev = elem.querySelector('.js-prev') as HTMLInputElement;
    let next = elem.querySelector('.js-next') as HTMLInputElement;

    prev?.addEventListener('click', () => {
      slider.previous();
    });

    next?.addEventListener('click', () => {
      slider.next();
    });

    // We have to do custom page dots because of the positioning in the design

    const parent = elem.parentElement;
    if (!parent) {
      return;
    }

    const dotsContainer = parent.querySelector<HTMLElement>('.flickity-page-dots');
    if (!dotsContainer) {
      return;
    }

    const dots = dotsContainer.querySelectorAll<HTMLButtonElement>('.flickity-page-dot');

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        slider.select(index);
      });
    });

    function updateDots() {
      const selectedIndex = slider.selectedIndex;

      dots.forEach((dot, i) => {
        if (i === selectedIndex) {
          dot.classList.add('is-selected');
          dot.setAttribute('aria-step', 'current');
        } else {
          dot.classList.remove('is-selected');
          dot.removeAttribute('aria-step');
        }
      });
    }

    updateDots();

    slider.on('change', updateDots);
  });

  modelModalBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const index = btn.dataset.index;
      const modal = btn.dataset.modal ? document.querySelector(`.js-modal[data-modal="${btn.dataset.modal}"]`) : undefined;

      if (!modal) {
        return;
      }

      const slider = Flickity.data(modal.querySelector('.js-rlx-model-modal-slider'));

      if (index && slider) {
        slider.select(index, true, true);
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const accordionBtns = document.querySelectorAll('.js-rlx-accordion-toggle');

  const updateOpenPanels = () => {
    accordionBtns?.forEach((btn) => {
      const parent = btn.closest('.js-rlx-accordion-item');
      const panel = parent?.querySelector<HTMLElement>('.js-rlx-accordion-panel');

      if (panel?.classList.contains('open')) {
        panel.style.maxHeight = `${panel.scrollHeight}px`;
      }
    });
  };

  accordionBtns?.forEach((btn) => {
    const parent = btn.closest('.js-rlx-accordion-item');

    // grab panel
    const panel = parent?.querySelector<HTMLElement>('.js-rlx-accordion-panel');

    if (panel && panel?.classList.contains('rlx-accordion__panel--open-default')) {
      panel.style.maxHeight = `${panel.scrollHeight}px`;
      panel.classList.remove('rlx-accordion__panel--open-default');
    }

    // if there are form steps in here we need to adjust the panel height on step change as well as on image lazyload
    const steps = panel?.querySelectorAll<HTMLElement>('.rlx-form__step');
    steps?.forEach((step) => {
      step.addEventListener('changed', ()=> {
        panel!.style.maxHeight = `${panel!.scrollHeight}px`;
      });

      let images = step.querySelectorAll('img');

      Array.from(images).forEach((img) => {
        img.addEventListener('load', () => {
          panel!.style.maxHeight = `${panel!.scrollHeight}px`;
        });
      });
    });

    btn.addEventListener('click', (e)=> {
      e.preventDefault;

      if (panel?.classList.contains('open')) {
        btn.classList.remove('open');
        panel.style.maxHeight = '0';
        panel.classList.remove('open');
        panel.setAttribute('aria-hidden', 'true');
      } else if (panel) {
        btn.classList.add('open');
        panel.style.maxHeight = `${panel.scrollHeight}px`;
        panel.classList.add('open');
        panel.removeAttribute('aria-hidden');
      }
    });
  });

  window.addEventListener('resize', () => {
    updateOpenPanels();
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const tabElements = document.querySelectorAll<HTMLElement>('.js-rlx-tabs');
  tabElements.forEach((elem) => {
    const tabs = Array.from(
      elem.querySelectorAll<HTMLButtonElement>('.js-rlx-tab-toggle')
    );
    const panels = Array.from(
      elem.querySelectorAll<HTMLElement>('.js-rlx-tab-panel')
    );

    function openTab(tab: HTMLButtonElement) {
      const targetPanelId = tab.getAttribute('aria-controls');
      const targetPanel = document.getElementById(targetPanelId!);

      tabs.forEach((t) => {
        const isActive = t === tab;
        t.setAttribute('aria-selected', String(isActive));
        t.tabIndex = isActive ? 0 : -1;
      });

      panels.forEach((panel) => {
        const isTarget = panel === targetPanel;
        panel.setAttribute('aria-hidden', String(!isTarget));

        const focusables = panel.querySelectorAll<HTMLElement>(
          'a, button, input, select, textarea, [tabindex]'
        );

        focusables.forEach((el) => {
          // Preserve original tabindex if needed
          if (!isTarget) {
            el.dataset.prevTabindex = el.getAttribute('tabindex') || '';
            el.tabIndex = -1;
          } else {
            if (el.dataset.prevTabindex !== undefined) {
              const previous = el.dataset.prevTabindex;
              if (previous) {
                el.setAttribute('tabindex', previous);
              } else {
                el.removeAttribute('tabindex');
              }
              delete el.dataset.prevTabindex;
            }
          }
        });
      });
    }

    // open first tab by default
    openTab(tabs[0]);

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        openTab(tab);
      });

      tab.addEventListener('keydown', (e) => {
        let index = tabs.indexOf(tab);
        if (e.key === 'ArrowRight') {
          index = (index + 1) % tabs.length;
          tabs[index].focus();
          openTab(tabs[index]);
          e.preventDefault();
        } else if (e.key === 'ArrowLeft') {
          index = (index - 1 + tabs.length) % tabs.length;
          tabs[index].focus();
          openTab(tabs[index]);
          e.preventDefault();
        }
      });
    });
  });
});

// detect keyboard tabbing - used for rolex contact form focus-visible states
const handleFirstTab = (e: KeyboardEvent) => {
  if (e.key === 'Tab') {
    document.body.classList.add('user-is-tabbing');
    window.removeEventListener('keydown', handleFirstTab);
    window.addEventListener('mousedown', handleMouseDownOnce);
  }
};

const handleMouseDownOnce = () => {
  document.body.classList.remove('user-is-tabbing');
  window.removeEventListener('mousedown', handleMouseDownOnce);
  window.addEventListener('keydown', handleFirstTab);
};

window.addEventListener('keydown', handleFirstTab);
